import { z } from 'zod'

export const FioBankCredentialsFormSchema = z.object({
  accountNumber: z.string().min(1, {
    message: 'bank.fio.form.accountNumber.required',
  }).regex(/^([0-9]{1,4}-)?[0-9]{8,10}$/, {
    message: 'bank.fio.form.accountNumber.errors.invalid',
  }),
  iban: z.string().min(1, {
    message: 'bank.fio.form.iban.required',
  }),
  currency: z.string().regex(/^[A-Z]{3}$/, {
    message: 'bank.fio.form.currency.errors.invalid',
  }),
  name: z.string().optional(),
  token: z.string().min(1, {
    message: 'bank.fio.form.token.required',
  }),
})
